<template>
  <div id="app">

    <el-header v-if="this.$route.path.toLowerCase() !== '/login' && this.$route.path.toLowerCase() !== '/nozone'"
      style="z-index: 5 !important;" :class="this.$route.path === '/home' ? 'topBar' : 'topBar2'">
      <div class="topBG">
        <el-tooltip class="item" effect="light" content="这是我俩" placement="top-start">
          <img src="https://img.codesocean.top/image/1666771403161" class="logo" @click="aboutUs()">
        </el-tooltip>
        <el-button type="text" class="topBarBtn" @click="home()">
          四周年有你
        </el-button>
        <el-button type="text" class="topBarBtn" @click="ourStory()">
          我们的故事
        </el-button>
        <el-button type="text" class="topBarBtn" @click="ourSpace()" v-if="this.$userInfo.$userLimit <= '1'">
          我们的小空间
        </el-button>
        <el-button type="text" class="topBarBtn" @click="time()" v-if="this.$userInfo.$userLimit <= '1'">
          我们一起走过
        </el-button>
        <el-button type="text" class="topBarBtn" @click="successfulMaster()" v-if="this.$userInfo.$userLimit <= '2'">
          成功大师的演讲
        </el-button>
        <el-button type="text" class="topBarBtn" @click="logout()">
          退出
        </el-button>
      </div>
    </el-header>

    <router-view></router-view>


  </div>
</template>
<script>
export default {
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true,
      backDisable: false,
    }
  },
  reload() {
    this.isRouterAlive = false
    this.$nextTick(() => (this.isRouterAlive = true))
  }
}
</script>


<script>
export default {
  mounted() {
    var new_date = new Date();                      //新建一个日期对象，默认现在的时间
    var old_date = new Date("2018-11-10 00:00:00"); //设置过去的时间点
 
    var subtime = (new_date - old_date) / 1000;    //计算时间差,并将毫秒转化为秒
    var days = parseInt(subtime / 86400) + 1;  //天  24*60*60*1000
    this.day = days.toString();
  },
  created() {
  },
  components: {

  },
  data() {
    return {
      day:''
    };
  },
  methods: {
    successfulMaster() {
      if(this.$route.path === '/successfulMaster') {
        this.$message({
          message:'已经进入群聊咯'
        });
      } else {
        this.$router.push("/successfulMaster");
      }
    },
    home() {
      if(this.$route.path === '/home') {
        this.$message({
          message:'已经在首页咯'
        });
      } else {
        this.$router.push("/home");
      }
    },
    ourStory() {
      if(this.$route.path === '/ourStory') {
        this.$message({
          message:'已经到我们的小故事咯'
        });
      } else {
        this.$router.push("/ourStory");
      }
    },
    logout() {
      this.$confirm('确定退出登陆吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$userInfo.$userLimit = '';
        this.$userInfo.$userName = '';
        this.$router.push('/Login');
      }).catch(() => {
        
      });
    },
    aboutUs() {
      if(this.$route.path === '/aboutUs') {
        this.$message({
          message:'已经在我们的页面咯'
        });
      } else {
        this.$router.push("/aboutUs");
      }
    },
    time() {
      if(this.$route.path === '/time') {
        this.$message({
          message:'已经在我们一起走过的时间咯'
        });
      } else {
        this.$router.push("/time");
      }
    },
    ourSpace() {
      if(this.$route.path === '/ourSpace') {
        this.$message({
          message:'已经在我们的小空间咯'
        });
      } else {
        this.$router.push("/ourSpace");
      }
    },
  }
}
</script>
<style scoped lang="scss">
.el-header * {
  user-select: none;
}

#app {
  overflow-x: hidden;
  overflow-y: hidden;
  height: 100%;
  width: 100%;
  position: absolute;
  // background-color: #bfa;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.topBar {
  line-height: 10vh !important;
  height: 10vh !important;
  background-color: transparent;

  .logo {
    height: 3vh;
    width: auto;
    position: relative;
    top: 1.5vh;
    left: 10vw;
    margin-right: 2vw;
    float: left;
    opacity: 0.8;
    transition: 300ms;
  }

  .logo:hover {
    opacity: 1;
    cursor: pointer;
  }

  .topBarBtn {
    font-family: 'HMOS_Regular';
    position: relative;
    color: #fff;
    font-size: 1.75vh;
    line-height: 1vh;
    top: 1.75vh;
    left: 10vw;
    margin-right: 2vw;
    float: left;
    opacity: 0.8;
    transition: 300ms;
  }

  .topBarBtn:hover {
    opacity: 1;
  }
}

.topBar2 {
  background-color: #8f2227cc !important;
  line-height: 10vh !important;
  height: 10vh !important;
  position: relative;

  .logo {
    height: 3vh;
    width: auto;
    position: relative;
    top: 1.5vh;
    left: 10vw;
    margin-right: 2vw;
    float: left;
    opacity: 0.8;
    transition: 300ms;
  }

  .logo:hover {
    opacity: 1;
    cursor: pointer;
  }

  .topBarBtn {
    font-family: 'HMOS_Regular';
    position: relative;
    color: #fff;
    font-size: 1.75vh;
    line-height: 1vh;
    top: 1.75vh;
    left: 10vw;
    margin-right: 2vw;
    float: left;
    opacity: 0.8;
    transition: 300ms;
  }

  .topBarBtn:hover {
    opacity: 1;
  }
}


.el-header {
  margin-top: 0px;
  // border-bottom: #B3C0D1 1px dotted;
  box-shadow: 0px 10px 10px #00000011;
  background-color: rgba(255, 255, 255, 0.15);
  color: #333;
  text-align: center;
  height: 6vh !important;
  width: 100%;
  padding-left: 0px;
  float: left;
  backdrop-filter: blur(5px);

  .topBG {
    width: 100%;
    height: 10vh !important;
  }
}

.el-footer {
  // border-radius: 10px;
  margin-bottom: 1px;
  // border-top: #B3C0D1 1px dotted;
  box-shadow: 0px -10px 10px #00000011;
  background-color: #fff;
  color: #333;
  text-align: center;
  line-height: 25px;
  height: 25px !important;
  color: gray;
  font-size: 15px;
}

.el-aside {
  background-image: linear-gradient(to top right, #305699, #89a5d8);
  z-index: 5;
  background-color: #001428;
  color: #333;
  text-align: center;

  .el-menu {
    margin-top: 50px;
  }

}

.el-main {
  background-color: #f5f7f8;
  width: 100vw;
  height: 100vh;
}

#app>.el-container {
  height: 100%;
}

.el-menu {
  border-right: 0px;

  .el-menu-item {
    i {
      color: #fff
    }
  }
}

// .el-menu-item:hover {
//   background-color: #fff !important;
// }

/deep/.el-menu .el-menu-item:hover {
  // border-top-left-radius: 20px;
  // border-bottom-left-radius: 20px;
  background-color: #fff3 !important;
  color: #fff;

  span {
    color: #fff !important;
  }
}

/deep/.el-menu .el-menu-item.is-active {
  background-color: #fff;
  // border-top-left-radius: 20px;
  // border-bottom-left-radius: 20px;

  span {
    color: #fff !important;
  }
}

.el-submenu /deep/.el-submenu__title:hover {
  // border-top-left-radius: 20px;
  // border-bottom-left-radius: 20px;
  background-color: #fff3 !important;

  i {
    color: #fff
  }
}

.el-submenu /deep/.el-submenu__title {

  // border-top-left-radius: 20px;
  // border-bottom-left-radius: 20px;
  i {
    color: #fff
  }
}
</style>
